module.exports = __webpack_public_path__ + "staticV3/img/9b3cfa39.empty-shop.png";